// Plain CSS entrance (index.css `.animate-fade-up`) instead of framer-motion:
// this was the ONLY framer-motion importer in the app, and it alone kept
// ~120 KB raw (~40 KB gzipped) of motion runtime in the always-loaded entry
// chunk (bundle attribution 2026-10-26).
export default function EmptyState({ icon: Icon, title, subtitle, action }) {
  return (
    <div className="animate-fade-up flex flex-col items-center justify-center py-16 text-slate-400 dark:text-slate-500">
      {Icon && <Icon size={36} className="mb-3 text-slate-300 dark:text-slate-600" />}
      {title && <p className="text-sm font-medium text-slate-600 dark:text-slate-400">{title}</p>}
      {subtitle && <p className="text-xs mt-1 text-center max-w-xs">{subtitle}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
